import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-transaction-order-table-shared",
  templateUrl: "./transaction-order-table-shared.component.html",
  styleUrls: ["./transaction-order-table-shared.component.scss"],
})
export class TransactionOrderTableSharedComponent implements OnInit, OnChanges {
  @Input() paymentReceipt: any;
  @Input() paymentReceiptCopy: any;
  @Input() currency: any;
  @Input() pRefundModalPageOne: any;
  @Input() refundProductList: any[];
  // @Input() refundProductListCopy: any[];

  @Input() totalPartialRefund: any;
  // @Output() addProductsInListToRefund: EventEmitter<any> = new EventEmitter();
  @Output() addProductsInListToRefund: EventEmitter<{ product: any, value: any }> = new EventEmitter();

  constructor() {}

  // paymentReceiptCopy: any;
  ngOnInit(): void {
    // this.paymentReceiptCopy = { ...this.paymentReceipt };
    console.log("this.paymentReceipt", this.paymentReceipt)
    // console.log("this.paymentReceiptCopy", this.paymentReceiptCopy)
    console.log("this.totalPartialRefund", this.totalPartialRefund)
    // this.getDiscountNames(this.paymentReceipt)

    if (!Boolean(this.currency)) {
      this.currency = "$";
    }

    // if(this.refundProductList.length) {
    //    // this.refundProductList = [];
    // this.refundProductList.forEach((data) => {
    //   // this.selectedQuantity[variant.orderedProductId] = data.productQuantity;
    //   return data;
    // });
    // } else {
      // console.log("this.refundProductListCopy", this.refundProductListCopy)
      this.paymentReceipt.orderId.seats.forEach((product) => {
        product.orderProducts.forEach((variant) => {
          if(this.refundProductList.length) {
            const foundProduct = this.refundProductList.find((data) => data.orderedProductId == variant.orderedProductId);
            if (foundProduct) {
              const index = this.refundProductList.indexOf(foundProduct);
              this.selectedQuantity[variant.orderedProductId] = this.refundProductList[index].productQuantity;
              console.log("FOUND_QUANTITY", this.selectedQuantity[variant.orderedProductId])
              console.log("FOUND_PREV_QUANTITY", this.prevQuantity)
            } else if(!foundProduct) {
              this.selectedQuantity[variant.orderedProductId] = variant.productQuantity;
              console.log("NOT_FOUND_QUANTITY", this.selectedQuantity[variant.orderedProductId])
            }
            // this.refundProductList.forEach((data) => {
            //     this.selectedQuantity[variant.orderedProductId] = data.productQuantity;
            //       // return data;
            //     });
          } else {
            this.selectedQuantity[variant.orderedProductId] = variant.productQuantity;
          }
          console.log("this.selectedQuantity[variant.orderedProductId]", this.selectedQuantity[variant.orderedProductId])

        });
      });
    // }
      console.log("this.refundProductList", this.refundProductList)
      // this.refundProductList.map((data) => {
      //     data.quantity = data.productQuantity;
      //     return data;
      //   });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
  }

  // totalPartaialRefundAmount: any = 0;
  // getModifierAndAddonsPrice() {
  //   let modTotal = 0;
  //   let addonTotal = 0;
  //   this.paymentReceipt.orderId.seats.forEach((product) => {
  //     product.orderProducts.forEach((variant) => {
  //       if(variant.AllproductModifiers) {
  //         variant.modifierGroupById.forEach((modifier) => {
  //           modTotal += modifier.modifierTotalPrice;
  //         });
  //       }
  //       if(variant.productAddons) {
  //         variant.productAddons.forEach((addon) => {
  //           addonTotal += addon.addonTotalPrice;
  //         });
  //       }
  //     });
  //   });
  //   return this.totalPartaialRefundAmount = modTotal + addonTotal;
  // }

  getPriceForRecipe = (unitPrice, quantity) => {
    return quantity * unitPrice;
  };
  validateProductRefunded(product: any): string {
    return product.productSellStatus === 6 || product.productSellStatus === 7
      ? "line-through"
      : "none";
  }
  validateProductIngredients(ingredient: any): string {
    return ingredient.ingredientPrice == 0 || ingredient.ingredientValue == '0.00'
      ? "line-through"
      : "none";
  }
  // checkingCheckboxValue: boolean = false;
  addProductsInListToRefundFunc(product: any, event: any) {
    let value = event.target.checked;
    console.log("value", event)


    // Add the 'ShouldRemove' property to the product object
    product.shouldRemove = value;
    if(value){
    // If value is true call the 'addProductsInListToRefund2'
    console.log("this.selectedQuantity[product.orderedProductId]", this.selectedQuantity[product.orderedProductId]);
    const productCopy = JSON.parse(JSON.stringify(product));
  // this.prevQuantity = quantity;
    if (this.selectedQuantity[product.orderedProductId]) {
    // Convert the quantity to a number
    productCopy.productQuantity = this.selectedQuantity[product.orderedProductId];
    // product.productQuantity = quantity;
      }
  // Emit the updated product object
    console.log("PRODUCT_EMITTED")
  // this.checkingCheckboxValue = true;
    this.addProductsInListToRefund.emit(productCopy);
    } else {
    // this.addProductsInListToRefund.emit({product, value});
    this.addProductsInListToRefund.emit(product);
    }
  }
  isCheckedFunc(product: any) {
    // console.log("this.checkingCheckboxValue", this.checkingCheckboxValue)
    // console.log("this.refundProductList_FROM_CHECKED", this.refundProductList)
    // console.log("product_FROM_CHECING_CHECKBOX", product)
    // if(!this.checkingCheckboxValue){
    //     const productIdToRemove = product.productId;

    //     // Filter out the product with the specified productId
    //     this.refundProductList = this.refundProductList.filter(
    //       (data) => data.productId !== productIdToRemove
    //     );
    // }
    // console.log("this.refundProductList_REMOVING_PRODUCT", this.refundProductList)
    const existingObj = this.refundProductList.find(
      (currentProduct) => currentProduct.orderedProductId === product.orderedProductId
    );
    // if(this.refundProductList.length){
    //   this.checkingCheckboxValue = true;
    // } else {
    //   this.checkingCheckboxValue = false;
    // }
    if (existingObj) {
      return true;
    } else {
      return false;
    }
  }

  // addProductsInListToRefund2(product, event) {
  //   if (event) {
  //     product.productQuantity = event;
  //   }
  //   this.addProductsInListToRefund.emit(product);
  // }

  selectedQuantity: { [orderedProductId: string]: number } = {};
  prevQuantity: any;

  addProductsInListToRefund2(product: any, quantity: number) {
    console.log("this.totalPartialRefund2", this.totalPartialRefund)
  // Update the selected quantity for the specific orderedProductId
  this.selectedQuantity[product.orderedProductId] = quantity;
  // Create a copy of the product object
  // const productCopy = { ...product };
  const productCopy = JSON.parse(JSON.stringify(product));
  // this.prevQuantity = quantity;
  if (quantity) {
    // Convert the quantity to a number
    productCopy.productQuantity = Number(quantity);
    // product.productQuantity = quantity;
      }
  // Emit the updated product object
  console.log("PRODUCT_EMITTED")
  // this.checkingCheckboxValue = true;
  this.addProductsInListToRefund.emit(productCopy);
  // this.addProductsInListToRefund.emit(product);
}

  tempData:any = {}
  // Values are Retained in the DropDown
  getQuantityList = (product) => {
    // console.log("VARIANTS_", product)
    const variantsCopy = { ...product };
    let qty = variantsCopy.productQuantity;
    if(!this.tempData[variantsCopy.orderedProductId]){
      this.tempData[variantsCopy.orderedProductId] = []
      while(qty > 0){
        this.tempData[variantsCopy.orderedProductId].push(qty)
        qty--;
      }
    }
      return this.tempData[variantsCopy.orderedProductId];
  }

  // Function to get the discount names
  _getDiscountNames: string;
  getDiscountNames = (discount:any) => {
    // console.log("DISCOUNT", discount)
    // let discountsObj = [];
    // discountsObj.push(discount);
    // console.log("DISCOUNTS_OBJ", discountsObj)
    const discountNamesSet = [];
    // const seats = receipt?.orderId?.seats
    if(discount != undefined){
      // for(let item of seats){
        // for(let discounts of discountsObj){
          // const { productDiscount: { discountName, discountValue, discountType } } = discounts;
          if(discount.discountName && discount.discountValue){
            let discountSymbol = '';
            if (discount.discountType === 1) {
                discountSymbol = '%';
                discountNamesSet.push(`${discount.discountName} @${discount.discountValue}${discountSymbol}`);
            } else if (discount.discountType === 2) {
                discountSymbol = this.currency;
                discountNamesSet.push(`${discount.discountName} @${discountSymbol}${discount.discountValue}`);
            }
        }
        // }
      // }
    }
    this._getDiscountNames = discountNamesSet.length ? `(${discountNamesSet.join(', ')})` : null
    return this._getDiscountNames;
  }

}
